import dayjs from "dayjs";
import React from "react";

require("dayjs/locale/es");

dayjs.locale("es");

const FormatDate = ({ date = "", format = "YYYY-MM-DD", className = "" }) => {
  if (!date) return <span className={className}>{dayjs().format(format)}</span>;

  if (!dayjs(date).isValid()) return "";

  return <span className={className}>{dayjs(date).format(format)}</span>;
};

export default FormatDate;
